import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Pagination from "../../../helper/Pagination";
import { MdDelete, MdModeEditOutline, MdClose } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import { getTransactionsRequest } from "../../redux/actions/transactionActions";
import { getOemNames } from "../../redux/actions/oemActions";

const Transaction = () => {
  const dispatch = useDispatch();
  const { transactions, loading, pagination } = useSelector(
    (state) => state.transaction
  );
  const { oemNames, oemNamesLoading } = useSelector((state) => state.oem);
  const [statusFilter, setStatusFilter] = useState("active");
  const [searchTerm, setSearchTerm] = useState("");
  const [oemIdSearch, setOemIdSearch] = useState("");
  const [oemFilter, setOemFilter] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const clearDateRange = () => {
    setStartDate(null);
    setEndDate(null);
  };

  useEffect(() => {
    dispatch(getOemNames());
  }, [dispatch]);

  // Reset to page 1 when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  useEffect(() => {
    const params = {
      search: searchTerm,
      oemId: oemIdSearch,
      oemId: oemFilter?.value || "",
      limit: pagination.itemsPerPage,
      page: currentPage,
    };
    dispatch(getTransactionsRequest(params));
  }, [
    dispatch,
    currentPage,
    searchTerm,
    oemIdSearch,
    oemFilter?.value,
    pagination.itemsPerPage,
  ]);

  const filteredData = transactions.filter((item) => {
    const itemDate = new Date(item.paidAt);
    const matchesDateRange =
      (!startDate || itemDate >= startDate) &&
      (!endDate || itemDate <= endDate);
    return matchesDateRange;
  });

  return (
    <>
      <div className="page-container">
        <div className="page-card scroll-container">
          <div className="form-header">
            <h2>Transaction Management</h2>
          </div>
          <div className="table-section">
            <div className="d-flex justify-content-end gap-4 align-items-center mb-2">
              {/* <div className="">
                <button
                  className={`me-2 add-btn ${
                    statusFilter === "active" ? "active" : ""
                  }`}
                  onClick={() =>
                    setStatusFilter(statusFilter === "active" ? "" : "active")
                  }
                  style={{
                    background:
                      statusFilter === "active"
                        ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                        : statusFilter === "inactive"
                        ? "#f8f9fa"
                        : "",
                    color:
                      statusFilter === "active"
                        ? "white"
                        : statusFilter === "inactive"
                        ? "#666"
                        : "",
                  }}
                >
                  Active
                </button>
                <button
                  className={`add-btn ${
                    statusFilter === "inactive" ? "active" : ""
                  }`}
                  onClick={() =>
                    setStatusFilter(
                      statusFilter === "inactive" ? "" : "inactive"
                    )
                  }
                  style={{
                    background:
                      statusFilter === "inactive"
                        ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                        : statusFilter === "active"
                        ? "#f8f9fa"
                        : "",
                    color:
                      statusFilter === "inactive"
                        ? "white"
                        : statusFilter === "active"
                        ? "#666"
                        : "",
                  }}
                >
                  Inactive
                </button>
              </div> */}

              <div className="d-flex gap-3">
                <Select
                  value={oemFilter}
                  onChange={setOemFilter}
                  options={oemNames?.map((oem) => ({
                    value: oem._id,
                    label: oem.companyName,
                  }))}
                  placeholder="All OEM"
                  isClearable
                  isSearchable
                  classNamePrefix="react-select"
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "200px",
                    }),
                    control: (base) => ({
                      ...base,
                      minHeight: "30px",
                      height: "30px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      "&:hover": {
                        border: "1px solid #ddd",
                      },
                    }),
                  }}
                />
                <div className="position-relative">
                  <input
                    type="search"
                    placeholder="Search by Name..."
                    className="form-input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value.trimStart())}
                    style={{ width: "200px" }}
                  />
                  {searchTerm === "" && (
                    <div
                      className="position-absolute"
                      style={{
                        top: "50%",
                        right: "13px",
                        transform: "translateY(-50%)",
                        color: "#666",
                      }}
                    >
                      <FaSearch />
                    </div>
                  )}
                </div>
                {/* <div className="position-relative">
                  <input
                    type="search"
                    placeholder="Search by OEM ID..."
                    className="form-input"
                    value={oemIdSearch}
                    onChange={(e) => setOemIdSearch(e.target.value)}
                    style={{ width: "200px" }}
                  />
                  {oemIdSearch === "" && (
                    <div
                      className="position-absolute"
                      style={{
                        top: "50%",
                        right: "13px",
                        transform: "translateY(-50%)",
                        color: "#666",
                      }}
                    >
                      <FaSearch />
                    </div>
                  )}
                </div> */}
                {/* <div className="position-relative">
                  <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      const [start, end] = update;
                      setStartDate(start);
                      setEndDate(end);
                    }}
                    className="form-control"
                    placeholderText="Select date range"
                    popperProps={{ strategy: "fixed" }}
                    popperPlacement="bottom"
                    popperClassName="date-picker-popper"
                    wrapperClassName="date-picker-wrapper"
                    wrapperStyle={{
                      width: "100%",
                      height: "30px",
                    }}
                    calendarClassName="border-0 shadow"
                    customInput={
                      <input
                        style={{
                          height: "30px",
                          padding: "0.375rem 0.75rem",
                          paddingRight: "15px",
                          cursor: "pointer",
                          fontSize: "12px",
                          width: "200px",
                        }}
                      />
                    }
                  />
                  {(startDate || endDate) && (
                    <MdClose
                      className="position-absolute"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#666",
                        zIndex: 1001,
                      }}
                      onClick={clearDateRange}
                      title="Clear date range"
                    />
                  )}
                </div> */}
              </div>
            </div>
            <div className="table-scroll-wrapper">
              <table className="partners-table">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>User Name</th>
                    <th>Plan</th>
                    <th>Amount</th>
                    <th>OEM Partner</th>
                    <th>Currency</th>
                    <th>Status</th>
                    <th>Coupon Applied</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#666",
                        }}
                      >
                        <div className="loading-spinner">
                          <div className="spinner"></div>
                          <p>Loading...</p>
                        </div>
                      </td>
                    </tr>
                  ) : filteredData.length === 0 ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          color: "#666",
                        }}
                      >
                        No transaction data available
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((item, index) => (
                      <tr key={item._id}>
                        <td>
                          {(currentPage - 1) * pagination.itemsPerPage +
                            index +
                            1}
                        </td>
                        <td>
                          {(() => {
                            const name = `${item.user?.firstName || ""} ${
                              item.user?.lastName || ""
                            }`.trim();
                            if (!name) return "N/A";
                            return name
                              .split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase()
                              )
                              .join(" ");
                          })()}
                        </td>
                        <td>{item.plan?.name || "N/A"}</td>
                        <td>
                          {(() => {
                            const currencySymbols = {
                              usd: "$",
                              jpy: "¥",
                              yen: "¥",
                              hkd: "HK$",
                              sgd: "S$",
                              aud: "A$",
                            };
                            const symbol =
                              currencySymbols[item.currency?.toLowerCase()] ||
                              item.currency?.toUpperCase() ||
                              "";
                            const value = item.amount;
                            return `${symbol}${value}`;
                          })()}
                        </td>
                        <td>{item.oemPartner?.companyName || "__"}</td>
                        <td>{item.currency?.toUpperCase() || "N/A"}</td>
                        <td>
                          <span
                            className={`status-badge ${
                              item?.status === "succeeded"
                                ? "success"
                                : item.status === "pending"
                                ? "warning"
                                : "danger"
                            }`}
                          >
                            {item.status
                              ? item.status.charAt(0).toUpperCase() +
                                item.status.slice(1).toLowerCase()
                              : "N/A"}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`badge ${
                              item.couponApplied ? "bg-success" : "bg-secondary"
                            }`}
                          >
                            {item.couponApplied ? "Yes" : "No"}
                          </span>
                        </td>
                        <td>
                          {item.paidAt
                            ? new Date(item.paidAt).toLocaleDateString()
                            : "N/A"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <Pagination
              currentPage={currentPage}
              totalPages={pagination.totalPages}
              totalItems={pagination.totalItems}
              itemsPerPage={pagination.itemsPerPage}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Transaction;
